<template>
    <inertia-head>
        <title>Sajten för Sveriges företagare +200.000 familjer! Familjekortet</title>
        <meta name="description" content="Här hittar du grymma erbjudanden och rabattkoder som gör både vardagen, festen och semestern BILLIGARE och ROLIGARE för hela familjen.">
        <meta property="og:image" :content="`${$page.props.baseUrl}/assets/frontend/hero.jpg`" />
        <link rel="canonical" :href="canonical">
    </inertia-head>

    <div class="main about">
        <breadcrumb>
            <breadcrumb-item>
                <inertia-link href="/">Hem</inertia-link>
            </breadcrumb-item>
            <breadcrumb-item :last="true">
                <span>Om Familjekortet</span>
            </breadcrumb-item>
        </breadcrumb>

        <div class="title">
            <img src="/assets/frontend/baby_shop_landing.jpg" alt="Om Familjekortet">
            <h1 class="title-text"> {{ $t('about_us_caption') }}</h1>
        </div>
        <div class="description">

        <div class="description-text">

                Familjekortet gör vardagen, helgen, semestern och festen
                <span class="averta-black">ENKLARE</span>, <span class="averta-black">BÄTTRE</span> och <span class="averta-black">BILLIGARE</span> för barnfamiljen! Här hittar
                du grymma erbjudanden och schysta rabattkoder till både
                aktiviteter och produkter som passar hela familjen!
                Att vara medlem är alltid gratis och utan hakar.

                <p>
                <button type="button" class="btn btn-link text-white" data-bs-toggle="modal" data-bs-target="#readMoreAboutFamcard">
                Läs mer
                </button>
                </p>

                <!-- Modal -->
                <div class="modal fade" id="readMoreAboutFamcard" tabindex="-1" aria-hidden="true">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                    <div class="modal-body moreaboutfamcard">

                        <img alt="Familjekortet logga" src="/assets/frontend/logo.png" style="height:40px;margin-bottom:1.3em;">

                        <p class="mb-4">Familjekortet är ett rabattkort för barnfamiljen! Alla i familjen kan hitta utvalda erbjudanden hos oss. Du hittar oss på webben och i din telefon, och apparna hämtar du där appar finns.</p>

                        <h2  class="text-black">För dig som är medlem</h2>

                        <p>Som medlem är det helt gratis att vara med och du får direkt tillgång till alla erbjudanden. Här finns rabattkoder och kampanjer både från stora varumärken och dina lokala företag. Många erbjudanden är helt exklusiva för våra medlemmar! Vi kommer maila eller pusha erbjudanden om det är något vi tycker är extra bra. Ger du oss mer info om dig själv kommer vi kunna ge dig mer anpassade erbjudanden, men det väljer du som är medlem själv.</p>

                        <button v-if="!currentUser" class="mb-4 btn btn-danger register-button" type="button" data-bs-toggle="modal" data-bs-target="#registerModal"> {{ $t('register') }}</button>

                        <h2  class="text-black">För dig med företag som vill synas hos oss</h2>

                        <p>Vi på Familjekortet letar alltid efter duktiga och spännande företag som söker en tydlig målgrupp att marknadsföra sig mot. Vi arbetar med företag över hela landet och i alla branscher som är relevanta för barnfamiljen. Familjekortet.se är ett marknadsföringsverktyg och du betalar ett schysst, fast pris för att synas hos oss. Via “Mina sidor Företag” administrerar du själv din företagssida och lägger upp, och tidsstyr dina erbjudanden. Priset beror på hur mycket och vart du syns. Hör av dig till oss så berättar vi gärna mer!</p>

                        <a href="/kontakta-oss" class="mb-4 btn btn-danger register-button"> Kontakta oss om att bli partner</a>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" data-dismiss="modal">Stäng</button>
                    </div>
                    </div>
                </div>
                </div>

            </div>


        </div>
        <div class="title">
            <img alt="Third block background" src="/assets/frontend/girl_smile.jpg">
        </div>
        <div class="splash splash-about super">
            <img alt="Super splash" src="/assets/frontend/splash_super.svg">
            <h2 class="splash-text super">{{ $t('about_us_splash_super') }}</h2>
        </div>
        <div class="splash splash-about pang">
            <img alt="Pang splash" src="/assets/frontend/splash_pang.svg">
            <h2 class="splash-text pang">{{ $t('about_us_splash_pang') }}</h2>
        </div>
        <div class="title">
            <img alt="Sixth block background" src="/assets/frontend/girl_phone.jpg">
        </div>
        <div class="splash splash-about dunder">
            <img alt="Dunder splash" src="/assets/frontend/splash_dunder.svg">
            <h2 class="splash-text dunder">{{ $t('about_us_splash_dunder') }}</h2>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['canonical'],
        computed: {
            currentUser() {
                return this.$page.props.currentUser;
            },
        }
    }
</script>
